import React, { useMemo, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';

import StdDialog from 'components/Dialogs/NewStdDialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import QButton from 'components/QButton';
import ScheduledTransactionLightForm from 'components/Forms/ScheduledTransactionLightForm';

const ScheduledTransactionLightEditDialog = (props) => {

  const scheduledTransaction = useMemo(() => props.scheduledTransaction && props.scheduledTransaction.toJS ? props.scheduledTransaction.toJS() : props.scheduledTransaction || {},
    [props.scheduledTransaction]);

  const formInterfaceRef = useRef();

  const onHandleClose = useCallback((event, reason) => {
    if (reason === 'SUBMIT_BUTTON' || reason === 'ENTER_KEY_DOWN') { // update
      if (formInterfaceRef && formInterfaceRef.current.submit) {
        formInterfaceRef.current.submit();
      }
    } else if (formInterfaceRef && formInterfaceRef.current.remove) {
      formInterfaceRef.current.remove();
    }
  }, [formInterfaceRef]);

  return (
    <StdDialog
      title="New Recurring"
      showCloseButton
      dialogProps={{ maxWidth: 'xs' }}
      {...props}
      onHandleClose={onHandleClose}
    >
      <>
        <DialogContent>
          <ScheduledTransactionLightForm
            scheduledTransaction={scheduledTransaction}
            renderProps={(formInterface) => { formInterfaceRef.current = formInterface; }}
            submitted={() => props.onHandleClose && props.onHandleClose()}
          />
        </DialogContent>

        <DialogActions>
          <QButton
            id='scheduled-transaction-light-cancel'
            variant="outlined"
            onClick={(event) => onHandleClose(event, 'CANCEL_BUTTON')}
          >
            Cancel
          </QButton>

          <QButton
            id='scheduled-transaction-light-submit'
            variant="contained"
            type="submit"
            onClick={(event) => onHandleClose(event, 'SUBMIT_BUTTON')}
          >
            Create
          </QButton>
        </DialogActions>
      </>
    </StdDialog>
  );
};

ScheduledTransactionLightEditDialog.propTypes = {
  open: PropTypes.bool,
  onHandleClose: PropTypes.func,
  scheduledTransaction: PropTypes.object,
};

export default ScheduledTransactionLightEditDialog;
